import type { GetItemsPurchaseOrdersRequestProps } from '@services/api/ocNf/types'
import type { ItemsPurchaseOrdersFormDataProps } from '../context/types'

export const parseItemsPurchaseOrdersPayload = (formData: ItemsPurchaseOrdersFormDataProps | null) => {
  const payload: GetItemsPurchaseOrdersRequestProps = {
    routeParams: {
      filiCode: formData?.filiCode || '',
      competenceDate: formData?.competenceDate || '',
      supplierCode: formData?.supplierCode || ''
    },
    bodyParams: {
      purchaseOrderNumber: formData?.purchaseOrderNumber ? Number(formData?.purchaseOrderNumber) : null,
      currentPage: formData?.page || 1,
      itemsPerPage: formData?.itemsPerPage || 10,
      sortBy: formData?.sortType ? formData?.sortBy! : null,
      sortType: formData?.sortType || null
    }
  }

  return payload
}
